import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IAlisFatura_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IAlisFatura_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  Logout: boolean;
  Logout_dummy: boolean;
  goToSignInActivity: any;
  goToSignInActivity_dummy: any;
  InvoicePurchaseHeader: any[];
  InvoicePurchaseHeader_dummy: any[];
  GetInvoicePurchaseVendorChar: any[];
  GetInvoicePurchaseVendorChar_dummy: any[];
  ListUser: any[];
  ListUser_dummy: any[];
  GetImage: any[];
  GetImage_dummy: any[];
  ChangeVisibilityOf: string;
  ChangeVisibilityOf_dummy: string;
  GetVendorAccounts: any[];
  GetVendorAccounts_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  GetProductAttributes_bir: any[];
  GetProductAttributes_bir_dummy: any[];
  GetProductAttributes_iki: any[];
  GetProductAttributes_iki_dummy: any[];
  GetProductAttributes_uc: any[];
  GetProductAttributes_uc_dummy: any[];
  isComp258660Visible: "visible" | "hidden";
  isComp682682Visible: "visible" | "hidden";
  isComp531627Visible: "visible" | "hidden";
  isComp697441Visible: "visible" | "hidden";
  isComp467559Visible: "visible" | "hidden";
  isComp193066Visible: "visible" | "hidden";
  isComp346579Visible: "visible" | "hidden";
  isComp138208Visible: "visible" | "hidden";
  isComp671627Visible: "visible" | "hidden";
}

export class AlisFatura_ScreenBase extends React.PureComponent<
  IAlisFatura_ScreenProps,
  any
> {
  alisfatura_828244_value_kuikaSelectBoxRef: React.RefObject<any>;
  alisfatura_985884_value_kuikaDateRef: React.RefObject<any>;
  alisfatura_725547_value_kuikaDateRef: React.RefObject<any>;
  alisfatura_760966_value_kuikaAutoCompleteRef: React.RefObject<any>;
  alisfatura_537989_value_kuikaAutoCompleteRef: React.RefObject<any>;
  alisfatura_303536_value_kuikaAutoCompleteRef: React.RefObject<any>;
  alisfatura_209759_value_kuikaAutoCompleteRef: React.RefObject<any>;
  alisfatura_918270_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "10a0db45-eac7-4ffc-8246-041db2ced344",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "be6a8194-8b98-4f2a-866c-78876292b1e1",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 506053, PropertyName: "label", Value: "Profil" },
        { Id: 684579, PropertyName: "label", Value: "Çıkış Yap" },
        { Id: 796303, PropertyName: "value", Value: "Alış Faturaları" },
        { Id: 971430, PropertyName: "value", Value: "Genel Filtre" },
        { Id: 402453, PropertyName: "value", Value: "Zaman Filtresi" },
        { Id: 828244, PropertyName: "placeholder", Value: "Zaman Aralığı" },
        { Id: 998768, PropertyName: "value", Value: "Başlangıç Tarihi" },
        {
          Id: 985884,
          PropertyName: "placeholder",
          Value: "Başlangıç Tarihi Seçiniz...",
        },
        { Id: 359696, PropertyName: "value", Value: "Bitiş Tarihi" },
        {
          Id: 725547,
          PropertyName: "placeholder",
          Value: "Bitiş Tarihi Seçiniz...",
        },
        { Id: 221257, PropertyName: "label", Value: "Filtreyi Uygula" },
        { Id: 945312, PropertyName: "value", Value: "Tedarikçi Filtresi" },
        { Id: 760966, PropertyName: "placeholder", Value: "Tedarikçi" },
        { Id: 973008, PropertyName: "value", Value: "Detaylı Filtre" },
        { Id: 312569, PropertyName: "value", Value: "Koleksiyon Filtresi" },
        { Id: 537989, PropertyName: "placeholder", Value: "Koleksiyon" },
        { Id: 33267, PropertyName: "value", Value: "Desen Filtresi" },
        { Id: 303536, PropertyName: "placeholder", Value: "Desen" },
        { Id: 958624, PropertyName: "value", Value: "Ebat Filtresi" },
        { Id: 209759, PropertyName: "placeholder", Value: "Ebat" },
        { Id: 691443, PropertyName: "label", Value: "Temizle" },
        { Id: 65662, PropertyName: "label", Value: "Ara" },
        { Id: 621226, PropertyName: "value", Value: "Verilen Sipariş" },
        { Id: 887540, PropertyName: "value", Value: "adet" },
        { Id: 134337, PropertyName: "value", Value: "metrekare" },
        { Id: 93650, PropertyName: "value", Value: "Gelen Sipariş" },
        { Id: 275592, PropertyName: "value", Value: "adet" },
        { Id: 449946, PropertyName: "value", Value: "metrekare" },
        { Id: 485715, PropertyName: "value", Value: "Kalan Sipariş" },
        { Id: 358902, PropertyName: "value", Value: "adet" },
        { Id: 328802, PropertyName: "value", Value: "metrekare" },
        { Id: 179345, PropertyName: "value", Value: "Toplam Alış Miktarı" },
        { Id: 427168, PropertyName: "value", Value: "Adet" },
        { Id: 576311, PropertyName: "value", Value: "Metrekare" },
        { Id: 586335, PropertyName: "value", Value: "Toplam Alış Tutarı" },
        { Id: 832897, PropertyName: "value", Value: "Fiyat TL" },
        { Id: 169766, PropertyName: "value", Value: "Fiyat Dolar" },
        {
          Id: 449879,
          PropertyName: "value",
          Value: "Koleksiyon Bazında Satın Alım",
        },
        { Id: 736283, PropertyName: "value", Value: "Top 5 Tedarikçiler" },
        {
          Id: 918270,
          PropertyName: "nodatafoundmessage",
          Value: "Veri Bulunamadı",
        },
        { Id: 455037, PropertyName: "title", Value: "Title" },
        { Id: 818910, PropertyName: "value", Value: "Unvan" },
        {
          Id: 474714,
          PropertyName: "value",
          Value: "[datafield:vendordescriptionlong]",
        },
        { Id: 319004, PropertyName: "value", Value: "Miktar" },
        { Id: 54951, PropertyName: "value", Value: "[datafield:miktar]" },
        { Id: 47645, PropertyName: "value", Value: "M2" },
        { Id: 705783, PropertyName: "value", Value: "[datafield:metrekare]" },
        { Id: 212910, PropertyName: "value", Value: "Tutar" },
        { Id: 456840, PropertyName: "value", Value: "[datafield:tutar]" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.alisfatura_828244_value_kuikaSelectBoxRef = React.createRef();
    this.alisfatura_985884_value_kuikaDateRef = React.createRef();
    this.alisfatura_725547_value_kuikaDateRef = React.createRef();
    this.alisfatura_760966_value_kuikaAutoCompleteRef = React.createRef();
    this.alisfatura_537989_value_kuikaAutoCompleteRef = React.createRef();
    this.alisfatura_303536_value_kuikaAutoCompleteRef = React.createRef();
    this.alisfatura_209759_value_kuikaAutoCompleteRef = React.createRef();
    this.alisfatura_918270_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      Logout: false,
      goToSignInActivity: "",
      InvoicePurchaseHeader: [],
      GetInvoicePurchaseVendorChar: [],
      ListUser: [],
      GetImage: [],
      ChangeVisibilityOf: "",
      GetVendorAccounts: [],
      SetValueOf: "",
      GetProductAttributes_bir: [],
      GetProductAttributes_iki: [],
      GetProductAttributes_uc: [],
      dataSource_828244: [
        { key: "10", text: "İki Tarih Arası Filtreleme" },
        { key: "8", text: "Ay Başından Bu Yana" },
        { key: "9", text: "Geçen Ay" },
        { key: "1", text: "Bugün" },
        { key: "2", text: "Son 7 Gün" },
        { key: "3", text: "Son 1 Ay" },
        { key: "4", text: "Son 3 Ay" },
        { key: "5", text: "Son 6 Ay" },
        { key: "6", text: "Son 1 Yıl" },
        { key: "7", text: "Tüm Tarihler" },
      ],
      isComp258660Visible: "hidden",
      isComp682682Visible: "visible",
      isComp531627Visible: "hidden",
      isComp697441Visible: "hidden",
      isComp467559Visible: "visible",
      isComp193066Visible: "hidden",
      isComp346579Visible: "hidden",
      isComp138208Visible: "hidden",
      isComp671627Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("alisfatura", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.AlisFaturaPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("alisfatura", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("alisfatura", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.AlisFaturaPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  AlisFaturaPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(3, "number"),
      productAtt03Desc_0: ReactSystemFunctions.convertToTypeByName(
        "",
        "string"
      ),
      productAtt05Desc_0: ReactSystemFunctions.convertToTypeByName(
        "",
        "string"
      ),
      productAtt07Desc_0: ReactSystemFunctions.convertToTypeByName(
        "",
        "string"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      endDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      customerCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      dateFilter_1: ReactSystemFunctions.convertToTypeByName(3, "number"),
      kUserId_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.ListUser !== undefined
            ? stateVars.ListUser?.length > 0
              ? stateVars.ListUser[0].id
              : null
            : this.state.ListUser?.length > 0
            ? this.state.ListUser[0].id
            : null
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "AlisFatura/AlisFaturaPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.InvoicePurchaseHeader = result?.data.invoicePurchaseHeader;
    formVars.alisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty1
        : null
    );
    formVars.alisfatura_635089_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty2
        : null
    );
    formVars.alisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty1
        : null
    );
    formVars.alisfatura_63718_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty2
        : null
    );
    formVars.alisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty1
        : null
    );
    formVars.alisfatura_747445_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty2
        : null
    );
    formVars.alisfatura_253556_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceQty1
        : null
    );
    formVars.alisfatura_667284_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceQty2
        : null
    );
    formVars.alisfatura_909494_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceAmount
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceAmount
        : null
    );
    formVars.alisfatura_391958_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceAmountU
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceAmountU
        : null
    );
    stateVars.GetInvoicePurchaseVendorChar =
      result?.data.getInvoicePurchaseVendorChar;

    stateVars.ListUser = result?.data.listUser;
    stateVars.GetImage = result?.data.getImage;
    formVars.alisfatura_619646_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AlisFaturaPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AlisFaturaPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.alisfatura_619646_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );

    formVars.alisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty1
        : null
    );

    formVars.alisfatura_635089_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty2
        : null
    );

    formVars.alisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty1
        : null
    );

    formVars.alisfatura_63718_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty2
        : null
    );

    formVars.alisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty1
        : null
    );

    formVars.alisfatura_747445_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty2
        : null
    );

    formVars.alisfatura_253556_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceQty1
        : null
    );

    formVars.alisfatura_667284_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceQty2
        : null
    );

    formVars.alisfatura_909494_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceAmount
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceAmount
        : null
    );

    formVars.alisfatura_391958_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceAmountU
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceAmountU
        : null
    );

    stateVars.dataSource_918270 =
      stateVars.GetInvoicePurchaseVendorChar ??
      this.state.GetInvoicePurchaseVendorChar;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  AlisFaturaComponent_548561_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "AlisFatura",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "655260",
      null,
      "left",
      "true",
      "100vw",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AlisFaturaComponent_506053_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "AlisFatura",
      "ProfileScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AlisFaturaComponent_684579_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.Logout = await ReactSystemFunctions.logout();
    stateVars.tmpBoolResult = await ReactSystemFunctions.goToSignInActivity(
      this
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AlisFaturaComponent_682682_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp258660Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp682682Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp531627Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AlisFaturaComponent_682682_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  AlisFaturaComponent_682682_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {};

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "AlisFatura/AlisFaturaComponent_682682_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetVendorAccounts = result?.data.getVendorAccounts;

    formVars.alisfatura_760966_value =
      stateVars.GetVendorAccounts !== undefined
        ? stateVars.GetVendorAccounts?.length > 0
          ? stateVars.GetVendorAccounts[0].currAccCode
          : null
        : this.state.GetVendorAccounts?.length > 0
        ? this.state.GetVendorAccounts[0].currAccCode
        : null;
    formVars.alisfatura_760966_options = stateVars.GetVendorAccounts;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AlisFaturaComponent_682682_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AlisFaturaComponent_682682_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.alisfatura_760966_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetVendorAccounts !== undefined
        ? stateVars.GetVendorAccounts?.length > 0
          ? stateVars.GetVendorAccounts[0].currAccCode
          : null
        : this.state.GetVendorAccounts?.length > 0
        ? this.state.GetVendorAccounts[0].currAccCode
        : null
    );

    formVars.alisfatura_760966_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetVendorAccounts !== undefined
        ? stateVars.GetVendorAccounts?.length > 0
          ? stateVars.GetVendorAccounts[0].currAccCode
          : null
        : this.state.GetVendorAccounts?.length > 0
        ? this.state.GetVendorAccounts[0].currAccCode
        : null
    );

    stateVars.dataSource_760966 =
      stateVars.GetVendorAccounts ?? this.state.GetVendorAccounts;
    stateVars.dataSource_760966 =
      stateVars.GetVendorAccounts ?? this.state.GetVendorAccounts;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AlisFaturaComponent_531627_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp258660Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp682682Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp531627Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AlisFaturaComponent_828244_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_828244_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      productAtt03Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_537989_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      productAtt05Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_303536_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      productAtt07Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_209759_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      endDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
    };

    KuikaAppManager.showSpinner(this);
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_828244_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("10", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "AlisFatura/AlisFaturaComponent_828244_onChange",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.InvoicePurchaseHeader = result?.data.invoicePurchaseHeader;
      formVars.alisfatura_449595_value = ReactSystemFunctions.toString(
        this,
        stateVars.InvoicePurchaseHeader !== undefined
          ? stateVars.InvoicePurchaseHeader?.length > 0
            ? stateVars.InvoicePurchaseHeader[0].orderQty1
            : null
          : this.state.InvoicePurchaseHeader?.length > 0
          ? this.state.InvoicePurchaseHeader[0].orderQty1
          : null
      );
      formVars.alisfatura_635089_value = ReactSystemFunctions.toString(
        this,
        stateVars.InvoicePurchaseHeader !== undefined
          ? stateVars.InvoicePurchaseHeader?.length > 0
            ? stateVars.InvoicePurchaseHeader[0].orderQty2
            : null
          : this.state.InvoicePurchaseHeader?.length > 0
          ? this.state.InvoicePurchaseHeader[0].orderQty2
          : null
      );
      formVars.alisfatura_803416_value = ReactSystemFunctions.toString(
        this,
        stateVars.InvoicePurchaseHeader !== undefined
          ? stateVars.InvoicePurchaseHeader?.length > 0
            ? stateVars.InvoicePurchaseHeader[0].shipmentQty1
            : null
          : this.state.InvoicePurchaseHeader?.length > 0
          ? this.state.InvoicePurchaseHeader[0].shipmentQty1
          : null
      );
      formVars.alisfatura_63718_value = ReactSystemFunctions.toString(
        this,
        stateVars.InvoicePurchaseHeader !== undefined
          ? stateVars.InvoicePurchaseHeader?.length > 0
            ? stateVars.InvoicePurchaseHeader[0].shipmentQty2
            : null
          : this.state.InvoicePurchaseHeader?.length > 0
          ? this.state.InvoicePurchaseHeader[0].shipmentQty2
          : null
      );
      formVars.alisfatura_952707_value = ReactSystemFunctions.toString(
        this,
        stateVars.InvoicePurchaseHeader !== undefined
          ? stateVars.InvoicePurchaseHeader?.length > 0
            ? stateVars.InvoicePurchaseHeader[0].remainingQty1
            : null
          : this.state.InvoicePurchaseHeader?.length > 0
          ? this.state.InvoicePurchaseHeader[0].remainingQty1
          : null
      );
      formVars.alisfatura_747445_value = ReactSystemFunctions.toString(
        this,
        stateVars.InvoicePurchaseHeader !== undefined
          ? stateVars.InvoicePurchaseHeader?.length > 0
            ? stateVars.InvoicePurchaseHeader[0].remainingQty2
            : null
          : this.state.InvoicePurchaseHeader?.length > 0
          ? this.state.InvoicePurchaseHeader[0].remainingQty2
          : null
      );
      formVars.alisfatura_253556_value = ReactSystemFunctions.toString(
        this,
        stateVars.InvoicePurchaseHeader !== undefined
          ? stateVars.InvoicePurchaseHeader?.length > 0
            ? stateVars.InvoicePurchaseHeader[0].invoiceQty1
            : null
          : this.state.InvoicePurchaseHeader?.length > 0
          ? this.state.InvoicePurchaseHeader[0].invoiceQty1
          : null
      );
      formVars.alisfatura_667284_value = ReactSystemFunctions.toString(
        this,
        stateVars.InvoicePurchaseHeader !== undefined
          ? stateVars.InvoicePurchaseHeader?.length > 0
            ? stateVars.InvoicePurchaseHeader[0].invoiceQty2
            : null
          : this.state.InvoicePurchaseHeader?.length > 0
          ? this.state.InvoicePurchaseHeader[0].invoiceQty2
          : null
      );
      formVars.alisfatura_909494_value = ReactSystemFunctions.toString(
        this,
        stateVars.InvoicePurchaseHeader !== undefined
          ? stateVars.InvoicePurchaseHeader?.length > 0
            ? stateVars.InvoicePurchaseHeader[0].invoiceAmount
            : null
          : this.state.InvoicePurchaseHeader?.length > 0
          ? this.state.InvoicePurchaseHeader[0].invoiceAmount
          : null
      );
      formVars.alisfatura_391958_value = ReactSystemFunctions.toString(
        this,
        stateVars.InvoicePurchaseHeader !== undefined
          ? stateVars.InvoicePurchaseHeader?.length > 0
            ? stateVars.InvoicePurchaseHeader[0].invoiceAmountU
            : null
          : this.state.InvoicePurchaseHeader?.length > 0
          ? this.state.InvoicePurchaseHeader[0].invoiceAmountU
          : null
      );
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.AlisFaturaComponent_828244_onChange1_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.AlisFaturaComponent_828244_onChange1_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AlisFaturaComponent_828244_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_828244_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      stateVars.ChangeVisibilityOf =
        await ReactSystemFunctions.changeVisibilityOf(
          this,
          ReactSystemFunctions.convertToTypeByName(
            "isComp697441Visible",
            "string"
          ),
          ReactSystemFunctions.convertToTypeByName("visible", "string")
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.AlisFaturaComponent_828244_onChange2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.AlisFaturaComponent_828244_onChange2_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  AlisFaturaComponent_828244_onChange2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_828244_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      stateVars.ChangeVisibilityOf =
        await ReactSystemFunctions.changeVisibilityOf(
          this,
          ReactSystemFunctions.convertToTypeByName(
            "isComp697441Visible",
            "string"
          ),
          ReactSystemFunctions.convertToTypeByName("hidden", "string")
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.AlisFaturaComponent_828244_onChange3_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.AlisFaturaComponent_828244_onChange3_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  AlisFaturaComponent_828244_onChange3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_828244_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "alisfatura_985884_value",
          "string"
        ),
        "",
        null,
        false
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.AlisFaturaComponent_828244_onChange4_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.AlisFaturaComponent_828244_onChange4_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  AlisFaturaComponent_828244_onChange4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_828244_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "alisfatura_725547_value",
          "string"
        ),
        "",
        null,
        false
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.AlisFaturaComponent_828244_onChange5_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.AlisFaturaComponent_828244_onChange5_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  AlisFaturaComponent_828244_onChange5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_828244_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      formVars.alisfatura_449595_value = ReactSystemFunctions.toString(
        this,
        stateVars.InvoicePurchaseHeader !== undefined
          ? stateVars.InvoicePurchaseHeader?.length > 0
            ? stateVars.InvoicePurchaseHeader[0].orderQty1
            : null
          : this.state.InvoicePurchaseHeader?.length > 0
          ? this.state.InvoicePurchaseHeader[0].orderQty1
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.AlisFaturaComponent_828244_onChange6_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.AlisFaturaComponent_828244_onChange6_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  AlisFaturaComponent_828244_onChange6_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_828244_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      formVars.alisfatura_635089_value = ReactSystemFunctions.toString(
        this,
        stateVars.InvoicePurchaseHeader !== undefined
          ? stateVars.InvoicePurchaseHeader?.length > 0
            ? stateVars.InvoicePurchaseHeader[0].orderQty2
            : null
          : this.state.InvoicePurchaseHeader?.length > 0
          ? this.state.InvoicePurchaseHeader[0].orderQty2
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.AlisFaturaComponent_828244_onChange7_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.AlisFaturaComponent_828244_onChange7_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  AlisFaturaComponent_828244_onChange7_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_828244_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      formVars.alisfatura_803416_value = ReactSystemFunctions.toString(
        this,
        stateVars.InvoicePurchaseHeader !== undefined
          ? stateVars.InvoicePurchaseHeader?.length > 0
            ? stateVars.InvoicePurchaseHeader[0].shipmentQty1
            : null
          : this.state.InvoicePurchaseHeader?.length > 0
          ? this.state.InvoicePurchaseHeader[0].shipmentQty1
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.AlisFaturaComponent_828244_onChange8_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.AlisFaturaComponent_828244_onChange8_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  AlisFaturaComponent_828244_onChange8_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_828244_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      formVars.alisfatura_63718_value = ReactSystemFunctions.toString(
        this,
        stateVars.InvoicePurchaseHeader !== undefined
          ? stateVars.InvoicePurchaseHeader?.length > 0
            ? stateVars.InvoicePurchaseHeader[0].shipmentQty2
            : null
          : this.state.InvoicePurchaseHeader?.length > 0
          ? this.state.InvoicePurchaseHeader[0].shipmentQty2
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.AlisFaturaComponent_828244_onChange9_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.AlisFaturaComponent_828244_onChange9_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  AlisFaturaComponent_828244_onChange9_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_828244_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      formVars.alisfatura_952707_value = ReactSystemFunctions.toString(
        this,
        stateVars.InvoicePurchaseHeader !== undefined
          ? stateVars.InvoicePurchaseHeader?.length > 0
            ? stateVars.InvoicePurchaseHeader[0].remainingQty1
            : null
          : this.state.InvoicePurchaseHeader?.length > 0
          ? this.state.InvoicePurchaseHeader[0].remainingQty1
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.AlisFaturaComponent_828244_onChange10_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.AlisFaturaComponent_828244_onChange10_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  AlisFaturaComponent_828244_onChange10_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_828244_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      formVars.alisfatura_747445_value = ReactSystemFunctions.toString(
        this,
        stateVars.InvoicePurchaseHeader !== undefined
          ? stateVars.InvoicePurchaseHeader?.length > 0
            ? stateVars.InvoicePurchaseHeader[0].remainingQty2
            : null
          : this.state.InvoicePurchaseHeader?.length > 0
          ? this.state.InvoicePurchaseHeader[0].remainingQty2
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.AlisFaturaComponent_828244_onChange11_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.AlisFaturaComponent_828244_onChange11_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  AlisFaturaComponent_828244_onChange11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_828244_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      formVars.alisfatura_253556_value = ReactSystemFunctions.toString(
        this,
        stateVars.InvoicePurchaseHeader !== undefined
          ? stateVars.InvoicePurchaseHeader?.length > 0
            ? stateVars.InvoicePurchaseHeader[0].invoiceQty1
            : null
          : this.state.InvoicePurchaseHeader?.length > 0
          ? this.state.InvoicePurchaseHeader[0].invoiceQty1
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.AlisFaturaComponent_828244_onChange12_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.AlisFaturaComponent_828244_onChange12_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  AlisFaturaComponent_828244_onChange12_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_828244_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      formVars.alisfatura_667284_value = ReactSystemFunctions.toString(
        this,
        stateVars.InvoicePurchaseHeader !== undefined
          ? stateVars.InvoicePurchaseHeader?.length > 0
            ? stateVars.InvoicePurchaseHeader[0].invoiceQty2
            : null
          : this.state.InvoicePurchaseHeader?.length > 0
          ? this.state.InvoicePurchaseHeader[0].invoiceQty2
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.AlisFaturaComponent_828244_onChange13_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.AlisFaturaComponent_828244_onChange13_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  AlisFaturaComponent_828244_onChange13_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_828244_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      formVars.alisfatura_909494_value = ReactSystemFunctions.toString(
        this,
        stateVars.InvoicePurchaseHeader !== undefined
          ? stateVars.InvoicePurchaseHeader?.length > 0
            ? stateVars.InvoicePurchaseHeader[0].invoiceAmount
            : null
          : this.state.InvoicePurchaseHeader?.length > 0
          ? this.state.InvoicePurchaseHeader[0].invoiceAmount
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.AlisFaturaComponent_828244_onChange14_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.AlisFaturaComponent_828244_onChange14_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  AlisFaturaComponent_828244_onChange14_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_828244_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      formVars.alisfatura_391958_value = ReactSystemFunctions.toString(
        this,
        stateVars.InvoicePurchaseHeader !== undefined
          ? stateVars.InvoicePurchaseHeader?.length > 0
            ? stateVars.InvoicePurchaseHeader[0].invoiceAmountU
            : null
          : this.state.InvoicePurchaseHeader?.length > 0
          ? this.state.InvoicePurchaseHeader[0].invoiceAmountU
          : null
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  AlisFaturaComponent_221257_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_828244_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      productAtt03Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_537989_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      productAtt05Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_303536_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      productAtt07Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_209759_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_985884_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      endDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_725547_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "AlisFatura/AlisFaturaComponent_221257_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.InvoicePurchaseHeader = result?.data.invoicePurchaseHeader;
    formVars.alisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty1
        : null
    );
    formVars.alisfatura_635089_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty2
        : null
    );
    formVars.alisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty1
        : null
    );
    formVars.alisfatura_63718_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty2
        : null
    );
    formVars.alisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty1
        : null
    );
    formVars.alisfatura_747445_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty2
        : null
    );
    formVars.alisfatura_253556_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceQty1
        : null
    );
    formVars.alisfatura_667284_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceQty2
        : null
    );
    formVars.alisfatura_909494_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceAmount
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceAmount
        : null
    );
    formVars.alisfatura_391958_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceAmountU
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceAmountU
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AlisFaturaComponent_221257_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AlisFaturaComponent_221257_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.alisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty1
        : null
    );

    formVars.alisfatura_635089_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty2
        : null
    );

    formVars.alisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty1
        : null
    );

    formVars.alisfatura_63718_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty2
        : null
    );

    formVars.alisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty1
        : null
    );

    formVars.alisfatura_747445_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty2
        : null
    );

    formVars.alisfatura_253556_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceQty1
        : null
    );

    formVars.alisfatura_667284_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceQty2
        : null
    );

    formVars.alisfatura_909494_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceAmount
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceAmount
        : null
    );

    formVars.alisfatura_391958_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceAmountU
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceAmountU
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AlisFaturaComponent_760966_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_828244_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      productAtt03Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_537989_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      productAtt05Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_303536_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      productAtt07Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_209759_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_985884_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      endDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_725547_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "AlisFatura/AlisFaturaComponent_760966_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.InvoicePurchaseHeader = result?.data.invoicePurchaseHeader;
    formVars.alisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty1
        : null
    );
    formVars.alisfatura_635089_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty2
        : null
    );
    formVars.alisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty1
        : null
    );
    formVars.alisfatura_63718_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty2
        : null
    );
    formVars.alisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty1
        : null
    );
    formVars.alisfatura_747445_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty2
        : null
    );
    formVars.alisfatura_253556_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceQty1
        : null
    );
    formVars.alisfatura_667284_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceQty2
        : null
    );
    formVars.alisfatura_909494_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceAmount
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceAmount
        : null
    );
    formVars.alisfatura_391958_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceAmountU
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceAmountU
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AlisFaturaComponent_760966_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AlisFaturaComponent_760966_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.alisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty1
        : null
    );

    formVars.alisfatura_635089_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty2
        : null
    );

    formVars.alisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty1
        : null
    );

    formVars.alisfatura_63718_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty2
        : null
    );

    formVars.alisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty1
        : null
    );

    formVars.alisfatura_747445_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty2
        : null
    );

    formVars.alisfatura_253556_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceQty1
        : null
    );

    formVars.alisfatura_667284_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceQty2
        : null
    );

    formVars.alisfatura_909494_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceAmount
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceAmount
        : null
    );

    formVars.alisfatura_391958_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceAmountU
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceAmountU
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AlisFaturaComponent_467559_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp467559Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp193066Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp346579Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AlisFaturaComponent_467559_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  AlisFaturaComponent_467559_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Att03_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      Att05_0: ReactSystemFunctions.convertToTypeByName("", "string"),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "AlisFatura/AlisFaturaComponent_467559_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetProductAttributes_bir = result?.data.getProductAttributes_bir;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AlisFaturaComponent_467559_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AlisFaturaComponent_467559_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_537989 =
      stateVars.GetProductAttributes_bir ?? this.state.GetProductAttributes_bir;
    stateVars.dataSource_537989 =
      stateVars.GetProductAttributes_bir ?? this.state.GetProductAttributes_bir;

    stateVars.dataSource_303536 =
      stateVars.GetProductAttributes_iki ?? this.state.GetProductAttributes_iki;
    stateVars.dataSource_303536 =
      stateVars.GetProductAttributes_iki ?? this.state.GetProductAttributes_iki;

    stateVars.dataSource_209759 =
      stateVars.GetProductAttributes_uc ?? this.state.GetProductAttributes_uc;
    stateVars.dataSource_209759 =
      stateVars.GetProductAttributes_uc ?? this.state.GetProductAttributes_uc;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AlisFaturaComponent_193066_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp193066Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp467559Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp346579Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AlisFaturaComponent_537989_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Att03_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_537989_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      Att05_0: ReactSystemFunctions.convertToTypeByName("", "string"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "AlisFatura/AlisFaturaComponent_537989_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetProductAttributes_iki = result?.data.getProductAttributes_iki;

    formVars.alisfatura_303536_options = stateVars.GetProductAttributes_iki;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AlisFaturaComponent_537989_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AlisFaturaComponent_537989_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp138208Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );

    stateVars.dataSource_537989 =
      stateVars.GetProductAttributes_bir ?? this.state.GetProductAttributes_bir;
    stateVars.dataSource_537989 =
      stateVars.GetProductAttributes_bir ?? this.state.GetProductAttributes_bir;

    stateVars.dataSource_303536 =
      stateVars.GetProductAttributes_iki ?? this.state.GetProductAttributes_iki;
    stateVars.dataSource_303536 =
      stateVars.GetProductAttributes_iki ?? this.state.GetProductAttributes_iki;

    stateVars.dataSource_209759 =
      stateVars.GetProductAttributes_uc ?? this.state.GetProductAttributes_uc;
    stateVars.dataSource_209759 =
      stateVars.GetProductAttributes_uc ?? this.state.GetProductAttributes_uc;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AlisFaturaComponent_303536_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Att03_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_537989_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      Att05_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_303536_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "AlisFatura/AlisFaturaComponent_303536_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetProductAttributes_uc = result?.data.getProductAttributes_uc;

    formVars.alisfatura_209759_options = stateVars.GetProductAttributes_uc;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AlisFaturaComponent_303536_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AlisFaturaComponent_303536_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp671627Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );

    stateVars.dataSource_537989 =
      stateVars.GetProductAttributes_bir ?? this.state.GetProductAttributes_bir;
    stateVars.dataSource_537989 =
      stateVars.GetProductAttributes_bir ?? this.state.GetProductAttributes_bir;

    stateVars.dataSource_303536 =
      stateVars.GetProductAttributes_iki ?? this.state.GetProductAttributes_iki;
    stateVars.dataSource_303536 =
      stateVars.GetProductAttributes_iki ?? this.state.GetProductAttributes_iki;

    stateVars.dataSource_209759 =
      stateVars.GetProductAttributes_uc ?? this.state.GetProductAttributes_uc;
    stateVars.dataSource_209759 =
      stateVars.GetProductAttributes_uc ?? this.state.GetProductAttributes_uc;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AlisFaturaComponent_691443_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(3, "number"),
      productAtt03Desc_0: ReactSystemFunctions.convertToTypeByName(
        "",
        "string"
      ),
      productAtt05Desc_0: ReactSystemFunctions.convertToTypeByName(
        "",
        "string"
      ),
      productAtt07Desc_0: ReactSystemFunctions.convertToTypeByName(
        "",
        "string"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      endDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "AlisFatura/AlisFaturaComponent_691443_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.InvoicePurchaseHeader = result?.data.invoicePurchaseHeader;
    formVars.alisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty1
        : null
    );
    formVars.alisfatura_635089_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty2
        : null
    );
    formVars.alisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty1
        : null
    );
    formVars.alisfatura_63718_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty2
        : null
    );
    formVars.alisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty1
        : null
    );
    formVars.alisfatura_747445_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty2
        : null
    );
    formVars.alisfatura_253556_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceQty1
        : null
    );
    formVars.alisfatura_667284_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceQty2
        : null
    );
    formVars.alisfatura_909494_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceAmount
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceAmount
        : null
    );
    formVars.alisfatura_391958_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceAmountU
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceAmountU
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AlisFaturaComponent_691443_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AlisFaturaComponent_691443_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "alisfatura_537989_value",
        "string"
      ),
      "",
      null,
      "AttributeCode"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "alisfatura_303536_value",
        "string"
      ),
      "",
      null,
      "AttributeCode"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "alisfatura_209759_value",
        "string"
      ),
      "",
      null,
      "AttributeCode"
    );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp467559Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp193066Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp467559Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp346579Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "alisfatura_828244_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("3", "string"),
      null,
      "Key"
    );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp697441Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp258660Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp682682Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp531627Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    formVars.alisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty1
        : null
    );

    formVars.alisfatura_635089_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty2
        : null
    );

    formVars.alisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty1
        : null
    );

    formVars.alisfatura_63718_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty2
        : null
    );

    formVars.alisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty1
        : null
    );

    formVars.alisfatura_747445_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty2
        : null
    );

    formVars.alisfatura_253556_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceQty1
        : null
    );

    formVars.alisfatura_667284_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceQty2
        : null
    );

    formVars.alisfatura_909494_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceAmount
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceAmount
        : null
    );

    formVars.alisfatura_391958_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceAmountU
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceAmountU
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AlisFaturaComponent_65662_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_828244_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      productAtt03Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_537989_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      productAtt05Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_303536_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      productAtt07Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_209759_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_985884_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      endDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_725547_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "AlisFatura/AlisFaturaComponent_65662_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.InvoicePurchaseHeader = result?.data.invoicePurchaseHeader;
    formVars.alisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty1
        : null
    );
    formVars.alisfatura_635089_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty2
        : null
    );
    formVars.alisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty1
        : null
    );
    formVars.alisfatura_63718_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty2
        : null
    );
    formVars.alisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty1
        : null
    );
    formVars.alisfatura_747445_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty2
        : null
    );
    formVars.alisfatura_253556_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceQty1
        : null
    );
    formVars.alisfatura_667284_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceQty2
        : null
    );
    formVars.alisfatura_909494_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceAmount
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceAmount
        : null
    );
    formVars.alisfatura_391958_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceAmountU
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceAmountU
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AlisFaturaComponent_65662_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AlisFaturaComponent_65662_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.alisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty1
        : null
    );

    formVars.alisfatura_635089_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty2
        : null
    );

    formVars.alisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty1
        : null
    );

    formVars.alisfatura_63718_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty2
        : null
    );

    formVars.alisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty1
        : null
    );

    formVars.alisfatura_747445_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty2
        : null
    );

    formVars.alisfatura_253556_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceQty1
        : null
    );

    formVars.alisfatura_667284_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceQty2
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceQty2
        : null
    );

    formVars.alisfatura_909494_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceAmount
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceAmount
        : null
    );

    formVars.alisfatura_391958_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].invoiceAmountU
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].invoiceAmountU
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AlisFaturaComponent_417020_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "SAKoleksiyonBazindaSatinAlim",
      "customerCode",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SAKoleksiyonBazindaSatinAlim",
      "CustomerName",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccDescription"
          )
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "AlisFatura",
      "SAKoleksiyonBazindaSatinAlim",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [655260, ,] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.AlisFaturaPageInit();
    }
  }
}
